module.exports = __webpack_public_path__ + "img/481.9fec773d.png";